import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  refresh: false,
  toast: {
    show: false,
    message: "",
    callBack: () => {},
  },
};

const globalSlice = createSlice({
  name: "global/reducer",
  initialState,
  reducers: {
    setRefresh: (state) => {
      state.refresh = !state.refresh;
    },
    setToastConfig: (state, action) => {
      state.toast = action.payload;
    },
    setModalClose: (state, action) => {
      state.toast.show = action.payload;
    },
  },
});

export const { setRefresh, setToastConfig, setModalClose } =
  globalSlice.actions;

export const globalReducer = globalSlice.reducer;
